<template>
    <div class="container container--breadcrumb">
        <ul class="gh-breadcrumb">
            <li class="gh-breadcrumb__item">
                <span class="gh-breadcrumb__item__inner"><router-link to="/">Home</router-link></span>
                <span class="gh-breadcrumb__separator">{{ separator }}</span>
            </li>

            <slot></slot>
        </ul>
    </div>
</template>

<script>
    import ghBreadcrumbItem from './breadcrumbItem.vue';

    export default {
        components: {ghBreadcrumbItem},
        
        props: {
            separator: {
                type: String,
                default: '>'
            }
        }
    }
</script>